import InsuranceIntermediaryInfo from './views/main.c';
export default InsuranceIntermediaryInfo;
